import { render, staticRenderFns } from "./View-Doc-File.vue?vue&type=template&id=6e1a18dc&scoped=true&"
import script from "./View-Doc-File.vue?vue&type=script&lang=js&"
export * from "./View-Doc-File.vue?vue&type=script&lang=js&"
import style0 from "./View-Doc-File.vue?vue&type=style&index=0&id=6e1a18dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1a18dc",
  null
  
)

export default component.exports